const labels = {
  'basement': 'Basement',
  'bathroom': 'Bathroom',
  'bedroom': 'Bedroom',
  'canteen': 'Canteen',
  'classroom': 'Classroom',
  'conferenceroom': 'Conference room',
  'diningroom': 'Dining room',
  'elevator': 'Elevator',
  'garage': 'Garage',
  'gym': 'Gym',
  'hallway': 'Hallway',
  'hospitalroom': 'Hospital room',
  'kitchen': 'Kitchen',
  'laboratory': 'Laboratory',
  'laundryroom': 'Laundry room',
  'lecturehall': 'Lecture hall',
  'livingroom': 'Living room',
  'nursery': 'Nursery',
  'office': 'Office',
  'other': 'Other',
  'productionroom': 'Production room',
  'room': 'Room',
  'salesroom': 'Sales room',
  'storageroom': 'Storage room',
  'studio': 'Studio'
};

export const getRoomTypeLabel = key => labels[key];
